<template>
  <div>
    <div class="md-layout">
      <h3 class="md-layout-item md-size-100" style="margin-top: 0">
        Datos del Siniestro
        <slot name="header"></slot>
      </h3>

      <f-field
        label="No. Siniestro"
        :value="roadSinister.sinisterSinisterNumber"
      >
      </f-field>

      <f-field label="Cliente" :value="roadSinister.sinister.customerName">
      </f-field>

      <f-field label="Autopista" :value="roadSinister.highwayName"> </f-field>

      <f-field
        label="No. Requisición"
        :value="roadSinister.affected.requisitionNumber"
      >
      </f-field>
    </div>
    <div class="md-layout">
      <f-field label="Campamento" :value="roadSinister.camp.name"></f-field>
      <f-field label="Dirección" :value="roadSinister.camp.address"></f-field>
      <f-field
        label="Distancia a la salida"
        :value="roadSinister.camp.distanceToExit"
      ></f-field>
      <f-field
        label="KM de desemboque"
        :value="roadSinister.camp.highwayKm"
      ></f-field>
    </div>
  </div>
</template>

<script>
import FField from './../FField'

export default {
  name: 'SinisterInfo',
  props: {
  	roadSinister: {
  		type: Object,
  		default: () => {}
  	}
  },
  components: {
  	FField
  },
}
</script>




// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/ConceptsValidation/SinisterInfo.vue